// extracted by mini-css-extract-plugin
module.exports = {"back-button":"UserSubscriptions_back-button__VRu_6","wrapperWithShadow":"UserSubscriptions_wrapperWithShadow__PAlSm"};